export const routes = {
    root: '/',
    aboutUsView: '/arwine/nosotros',
    contactView: '/arwine/contacto',
    privateTourView: '/arwine/private-tour',
};